import React from 'react';
import {Link} from 'react-router';
import {DeleteDialog} from 'modules/dialog';
import {CheckPermission} from 'modules/login/CheckPermission';

export default class RowItemAdministrative extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.ma}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.ten}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.donViHanhChinhCha ? this.props.item.donViHanhChinhCha.ten : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.capDonViHanhChinhDVHC.ten}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>{this.props.item.moTa}</li>
          </ul>
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('DONVIHANHCHINH_THEM') ?
                <Link
                  className="itt-add"
                  onClick={this.props.parent.openAddMoreCategory.bind(this.props.parent, this.props.item)}>
                  Thêm đơn vị con
                </Link>
              : null
            }
            {
              CheckPermission('DONVIHANHCHINH_SUA') ?
                <Link
                  className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}>
                    Chỉnh sửa
                </Link>
              : null
            }
            {
              CheckPermission('DONVIHANHCHINH_XOA') ?
                <DeleteDialog
                  title= {'Xoá danh mục'}
                  content= {'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId = {this.props.item.donViHanhChinhId}
                />
              : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemAdministrative.jsx